<div class="swapSection my-3">
  <div class="text-center pb-2" *ngIf="walletAddress">
    <div class="ms-2 font-14 fw-semibold dashTitle" *ngIf="isNative && !isWert">{{isBsc ? 'BNB' : 'ETH'}} {{"balance" |
      translate }} {{nativeBal}}</div>
    <div class="ms-2 font-14 fw-semibold dashTitle" *ngIf="!isNative && !isWert">USDT {{"balance" | translate }}
      {{usdtBal}}</div>
  </div>


  <!-- ====== not started ====== -->

  <div class="body-section" *ngIf="status === SwapStatus.not_started">

    <div class="row">

      <div class="col-md-6 pe-md-1">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <label class="d-block family-title font-13 fw-normal text-truncate">
            {{"amount_in" | translate }}
            <span class="text-uppercase fw-bold">{{tokenName}}</span>
            {{"you_pay" | translate}}
          </label>
          <div class="fw-bold family-title cursor-pointer font-13" (click)="max()">{{"max" | translate}}</div>
        </div>

        <div class="amountField d-flex align-items-start">
          <!-- <div class="flex-grow-1" [ngClass]="{isLowBalance: isLowBalance && !isWert, isHighBalance: !isLowBalance && !isWert }"> -->
          <input #swapIn type="text" appTwoDigitDecimalNumber [noDecimal]="isNative ? 10 : 6"
            class="form-control text-truncate text-white" placeholder="0" [(ngModel)]="swapToken"
            (ngModelChange)="swapTokenUpdate.next($event)">
          <div class="amountType">
            <svg-icon
              src="./assets/images/svg-icons/{{isNative ? (isBsc ? 'bnb' : 'eth') : (isWert ? 'usd' : 'usdt')}}.svg"
              [svgStyle]="{ 'width.px':28,'height.px':28 }"></svg-icon>
          </div>
        </div>
      </div>

      <div class="col-md-6 ps-md-1 mt-3 mt-md-0">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <label class="d-block family-title font-13 fw-normal text-truncate">
            {{"amount_in" | translate}}
            <span class="text-uppercase fw-bold">{{cryptoName}}</span>
            {{"you_receive" | translate}}
          </label>
        </div>

        <div class="amountField">
          <input type="text" appTwoDigitDecimalNumber [noDecimal]="0" class="form-control text-truncate text-white"
            [(ngModel)]="baseToken" min="minAmount" (ngModelChange)="baseTokenUpdate.next($event)" pattern="\d*"
            placeholder="0">
          <div class="amountType">
            <svg-icon src="./assets/images/svg-icons/token.svg"
              [svgStyle]="{ 'width.px':28,'height.px':28 }"></svg-icon>
          </div>
        </div>
      </div>

      <!-- ----- low balance info and error section ----- -->
      <div class="col-12 text-center" *ngIf="walletAddress">
        <div class="lowBalance fs-7 m-2" *ngIf="!isLowBalance && !isWert">{{"gas_fees" | translate : {gasFees, modeName
          } }}</div>
        <div class="lowBalance fs-7 m-2" *ngIf="isNative && isLowBalance && !isWert">{{"low_gas_fees" | translate :
          {modeName } }}</div>
        <div class="lowBalance fs-7 m-2" *ngIf="!isNative && isLowBalance && !isWert">{{lowGas ? ("low_gas_fees" |
          translate : {modeName } ) : ("low_usdt" | translate) }}</div>

        <div class="text-center fs-7 mt-2 w-100 text-danger" *ngIf="baseToken && baseToken < minAmount && !isWert">
          {{"min_crypto" | translate : {minAmount, cryptoName} }}
        </div>

        <div class="text-center fs-7 mt-2 w-100 text-danger"
          *ngIf="baseToken && baseToken >= minAmount && isLowBalance && !isWert">
          {{"swap_error" | translate : {gasFees, modeName, tokenName } }}
        </div>
      </div>
    </div>




    <div class="d-flex align-items-center justify-content-center gap-2 mt-2" *ngIf="walletAddress">
      <button type="button" class="btn btn-secondary w-50 fs-6 fw-bold"
        [disabled]="(isLowBalance && !isWert) || !swapToken || swapToken == 0" (click)="confirm()"
        translate>buy_now</button>
      <button type="button" class="btn btn-secondary w-50 fs-6 fw-bold" *ngIf="!isBsc"
        [disabled]="(isLowBalance && !isWert) || !swapToken || swapToken == 0" (click)="confirm(true)"
        translate>buy_stake</button>
      <button type="button" class="btn btn-white w-50 fs-6 fw-bold" (click)="changeChain()" *ngIf="isBsc">{{'switch_to'
        | translate}}
        {{isBsc ? "ETH" : "BNB"}}</button>
    </div>
    <div class="d-flex align-items-center justify-content-center gap-2 mt-2" *ngIf="walletAddress && !isBsc">
      <button type="button" class="btn btn-white w-50 fs-6 fw-bold" (click)="changeChain()">{{'switch_to' | translate}}
        {{isBsc ? "ETH" : "BNB"}}</button>
    </div>
  </div>


  <!-- ====== show loader ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.in_progess">
    <img src="./assets/images/svg-icons/token.svg" alt="loading" class="statusIcon loading">
    <div class="fw-normal fw-bold font-16 px-2 my-3 text-uppercase  text-center">{{"transaction_in_progress" |
      translate}}</div>
    <p class="fs-7 mb-0 text-white">{{(isStake ? "transction_info_stake" : "transction_info") | translate: {baseToken}
      }}</p>
  </div>


  <!-- ====== show confirm ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.confirm_pending">
    <img src="./assets/images/svg-icons/token.svg" alt="loading" class="statusIcon loading">
    <div class="fw-semibold fs-6 my-3 text-uppercase text-center">{{"confirm" | translate}}</div>
    <p class="fs-7 mb-0 text-white" *ngIf="!isStake">{{"waiting_confirm" | translate : {cryptoName, tokenName } }}</p>
    <p class="fs-7 mb-0 text-white" *ngIf="isStake">{{"waiting_confirm_stake" | translate : {cryptoName, tokenName } }}</p>
    <p class="fs-7 mb-0 text-white" *ngIf="isStake">{{"waiting_confirm_stake_2" | translate : {cryptoName, tokenName } }}</p>
  </div>


  <!-- ====== show pending ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.approval_pending">
    <img src="./assets/images/svg-icons/token.svg" alt="loading" class="statusIcon loading">
    <div class="fw-semibold fs-6 my-3 text-uppercase text-center">{{"authorise" | translate}}</div>
    <p class="fs-7 mb-0 text-white">{{"waiting_approve" | translate : {cryptoName} }}</p>
  </div>


  <!-- ====== show success/completed ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.complete">
    <img src="./assets/images/popup-icons/success.svg" alt="complete" class="statusIcon">
    <div class="fw-semibold fs-6 my-3 text-uppercase text-success text-center">
      {{"transaction_success" | translate}}
    </div>
    <p class="fs-7 mb-3 mb-lg-4 text-white">{{(isStake ? "transction_info_stake_success" : "transction_info") |
      translate: {baseToken} }}</p>
    <a href="{{lang}}/dashboard" class="btn btn-md  btn-secondary w-50 fs-6 my-2 text-uppercase">{{"dashboard" |
      translate}}</a>
    <div class="d-flex align-items-center justify-content-center gap-2">
      <button (click)="viewUrl()" class="btn btn-md  btn-secondary w-50 fs-6 text-uppercase">{{"view_transaction" |
        translate}}</button>
      <button (click)="startAgain()" class="btn btn-md btn-secondary w-50 fs-6 text-uppercase">{{"start_again" |
        translate }}</button>
    </div>
  </div>


  <!-- ====== show failed ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.failed">
    <img src="./assets/images/popup-icons/warning.svg" alt="failed" class="statusIcon">
    <div class="fw-semibold fs-6 my-3 text-uppercase text-white text-center">
      {{"transaction_failed" | translate}}
    </div>
    <p class="fs-7 mb-3 mb-lg-4 text-white">{{"view_transaction_info" | translate}}</p>
    <div class="d-flex align-items-center justify-content-center gap-2">
      <button (click)="viewUrl()" class="btn btn-md  btn-secondary w-50 fs-6 text-uppercase">{{"view_transaction" |
        translate}}</button>
      <button (click)="startAgain()" class="btn btn-md btn-secondary w-50 fs-6 text-uppercase">{{"start_again" |
        translate }}</button>
    </div>
  </div>


  <!-- ====== show rejected ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.rejected">
    <img src="./assets/images/popup-icons/warning.svg" alt="failed" class="statusIcon">
    <div class="fw-semibold fs-6 text-uppercase text-white my-3 text-center">{{"transaction_rejected" | translate}}
    </div>
    <div class="d-flex align-items-center justify-content-center gap-2 mt-4">
      <button (click)="startAgain()" class="btn btn-md btn-secondary w-50 fs-6 text-uppercase">{{"start_again" |
        translate }}</button>
    </div>
  </div>

</div>